import {
  Button,
  Input,
  Form,
  notification,
  PageHeader,
  Col,
  Row,
  InputNumber,
  Switch,
} from "antd";
import { useEffect, useState } from "react";
import { Prompt, useHistory } from "react-router-dom";
import "../../Tools/customStyles.css";
import { useAuth } from "../../context/auth";
import IconEvCharger from "../../static/icon/IconEvCharger";
import MerchantDropdown from "../Dropdown/MerchantDropdown";
import LandlordDropdown from "../Dropdown/LandlordDropdown";
import ChargerBrandDropdown from "../Dropdown/ChargerBrandDropdown";
import ConnectorTypeDropdown from "../Dropdown/ConnectorTypeDropdown";
import PriceDropdown from "../Dropdown/PriceDropdown";
import IconQR from "../../static/icon/IconQR";
import ModalQR from "./ModalQR";
import { DeleteTwoTone, PlusOutlined } from "@ant-design/icons";

const ChargerSetting = ({ match: { params: { id } } }) => {
  const history = useHistory();
  const { accessToken, adminRole } = useAuth();

  const [form] = Form.useForm();
  const merchantId = Form.useWatch('merchantId', form);

  const [change, setChange] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (id === 'new') return;

    async function getCharger() {
      const url = new URL('/api/charger/' + id, window.location);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { charger } = await res.json();
        form.setFieldsValue(charger);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    setChange(false);
    getCharger();
  }, [accessToken, form, id]);

  const save = async (values) => {
    setDisabled(true);
    setChange(false);

    const url = new URL(id === 'new' ? '/api/charger' : '/api/charger/' + id, window.location);

    const res = await fetch(url, {
      method: id === 'new' ? 'POST' : 'PATCH',
      headers: {
        'X-ACCESS-TOKEN': accessToken,
        'content-type': 'application/json',
      },
      body: JSON.stringify(values),
    });
    if (res.ok) {
      notification["success"]({
        message: "Successfully saved data.",
      });
      history.push({
        pathname: "/charger",
        searchValue: history.location.searchValue,
        pageValue: history.location.pageValue,
      });
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setDisabled(false);
    setChange(true);
  };

  const [qrCode, setQrCode] = useState(null);

  return (
    <>
      <div className="flex justify-between items-center mt-2">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconEvCharger /> &nbsp;&nbsp;Charger Setting
            </span>
          }
        />
      </div>
      <div className="content">
        <div className="search">
          <Form
            form={form}
            onFinish={save}
            onFieldsChange={() => setChange(true)}
            className="search_inline row m-auto w-3/4 py-6"
          >
            <Row gutter={40} style={{ marginTop: 30 }}>
              <Col sm={24} md={24} lg={12}>
                <Form.Item
                  label="Charger Id"
                  name="id"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Charger Name (EN) is required.",
                    },
                  ]}
                  className="mt-2"
                >
                  <InputNumber
                    placeholder="Charger Id"
                    className="w-full"
                    disabled={id !== 'new'}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={40} style={{ marginTop: 15 }}>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Charger Name (EN)"
                  name="nameEn"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Charger Name (EN) is required.",
                    },
                    {
                      whitespace: true,
                      message: "Charger Name (EN) is not whitespace",
                    },
                  ]}
                  className="mt-2"
                >
                  <Input
                    placeholder="Charger Name (EN)"
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Charger Name (TH)"
                  name="nameTh"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Charger Name (TH) is required.",
                    },
                    {
                      whitespace: true,
                      message: "Charger Name (TH) is not whitespace",
                    },
                  ]}
                  className="mt-2"
                >
                  <Input
                    placeholder="Charger Name (TH)"
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              {['admin', 'callcenter', 'marketting'].includes(adminRole) && (
                <Col span={24} lg={12}>
                  <Form.Item
                    label="Cluster Name"
                    name="merchantId"
                    colon={false}
                    className="mt-2"
                  >
                    <MerchantDropdown
                      disabled={id !== 'new'}
                    />
                  </Form.Item>
                </Col>
              )}
              {['admin', 'merchant', 'party', 'callcenter', 'station', 'marketting'].includes(adminRole) && (
                <Col span={24} lg={12}>
                  <Form.Item
                    label="Site Name"
                    name="landlordId"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "Site Name is required.",
                      },
                    ]}
                    className="mt-2"
                  >
                    <LandlordDropdown
                      merchantIds={merchantId ? [merchantId] : []}
                      disabled={id !== 'new'}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={24} lg={12}>
                <Form.Item
                  label="Charger Brand"
                  name="chargerBrandId"
                  colon={false}
                  className="mt-2"
                  initialValue={null}
                >
                  <ChargerBrandDropdown
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Active"
                  name="active"
                  colon={false}
                  className="mt-2"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
            </Row>

            <Row className="border rounded-lg px-4 py-8 -mt-4">
              <Col span={24}>
                <Form.Item
                  label="Connector Detail"
                  className="-mb-1"
                />
                <Form.List
                  name="connectors"
                  initialValue={[{ isNew: true }]}
                >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(
                        ({ name }) => (
                          <Row key={name} gutter={[48, 0]}>
                            <Col span={24} lg={12}>
                              <Form.Item
                                label="Connector Id"
                                name={[name, "id"]}
                                colon={false}
                                rules={[
                                  {
                                    required: true,
                                    message: "Connector Id is required.",
                                  },
                                ]}
                                className="mt-2"
                              >
                                <InputNumber
                                  placeholder="Connector Id"
                                  className="w-full"
                                  disabled={!form.getFieldValue(['connectors', name, 'isNew'])}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={24} lg={12}>
                              <Form.Item
                                label="Token"
                                name={[name, "token"]}
                                colon={false}
                                rules={[
                                  {
                                    required: true,
                                    message: "Token is required.",
                                  },
                                  {
                                    whitespace: true,
                                    message: "Token is not whitespace",
                                  },
                                ]}
                                className="mt-2"
                              >
                                <Input
                                  placeholder="Token"
                                  maxLength={255}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={24} lg={12}>
                              <Form.Item
                                label="Name (EN)"
                                name={[name, "nameEn"]}
                                colon={false}
                                rules={[
                                  {
                                    required: true,
                                    message: "Name (EN) is required.",
                                  },
                                  {
                                    whitespace: true,
                                    message: "Name is not whitespace",
                                  },
                                ]}
                                className="mt-2"
                              >
                                <Input
                                  placeholder="Name (EN)"
                                  maxLength={255}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={24} lg={12}>
                              <Form.Item
                                label="Name (TH)"
                                name={[name, "nameTh"]}
                                colon={false}
                                rules={[
                                  {
                                    required: true,
                                    message: "Name (TH) is required.",
                                  },
                                  {
                                    whitespace: true,
                                    message: "Name is not whitespace",
                                  },
                                ]}
                                className="mt-2"
                              >
                                <Input
                                  placeholder="Name (TH)"
                                  maxLength={255}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={24} lg={12}>
                              <Form.Item
                                label={"Connector Type"}
                                name={[name, "connectorTypeId"]}
                                colon={false}
                                rules={[
                                  {
                                    required: true,
                                    message: "Connector Type is required.",
                                  },
                                ]}
                                className="mt-2"
                              >
                                <ConnectorTypeDropdown />
                              </Form.Item>
                            </Col>
                            <Col span={24} lg={12}>
                              <Form.Item
                                label="Judjod Id"
                                name={[name, "judjodId"]}
                                colon={false}
                                className="mt-2"
                              >
                                <InputNumber
                                  placeholder="Judjod Id"
                                  allowClear
                                  className="w-full"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={24} lg={12}>
                              <Form.Item
                                label="Charging Speed"
                                name={[name, "maxPowerKw"]}
                                colon={false}
                                rules={[
                                  {
                                    required: true,
                                    message: "Charging Speed is required.",
                                  },
                                ]}
                                className="mt-2"
                              >
                                <InputNumber
                                  min={0.01}
                                  maxLength={10}
                                  step="0.01"
                                  className="w-full"
                                  placeholder="0"
                                  allowClear
                                  addonAfter={
                                    <span className="text-gray-600">
                                      kW
                                    </span>
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={24} lg={12}>
                              <Form.Item
                                label="Old Qr"
                                name={[name, "oldQr"]}
                                colon={false}
                                rules={[
                                  {
                                    whitespace: true,
                                    message: "Old Qr is not whitespace",
                                  },
                                ]}
                                className="mt-2"
                              >
                                <Input
                                  placeholder="Old Qr"
                                  maxLength={255}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label={"Price Description"}
                                name={[name, "priceId"]}
                                colon={false}
                                rules={[
                                  {
                                    required: true,
                                    message: "Price Code is required.",
                                  },
                                ]}
                                className="mt-2"
                              >
                                <PriceDropdown />
                              </Form.Item>
                            </Col>
                            <Col span={24} lg={12}>
                              <Form.Item
                                label=" "
                                colon={false}
                                className="lg:mt-2 "
                              >
                                <div className="flex space-x-4">
                                  <div
                                    className="cursor-pointer hover:opacity-80"
                                    onClick={() => setQrCode(`${form.getFieldValue(['connectors', name, 'id'])}`)}
                                  >
                                    <IconQR />
                                  </div>
                                </div>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              {(id === 'new' || form.getFieldValue(['connectors', name, 'isNew'])) && (
                                <div className="flex justify-end mb-8 pb-3 border-b border-dashed">
                                  <DeleteTwoTone
                                    style={{
                                      backgroundColor: "#F3F6F9",
                                      padding: 6,
                                      borderRadius: 6,
                                    }}
                                    onClick={() => remove(name)}
                                    twoToneColor="red"
                                  />
                                </div>
                              )}
                            </Col>
                          </Row>
                        )
                      )}
                      <Form.Item>
                        <div className="flex justify-center">
                          <Button
                            style={{ background: "#F3F6F9" }}
                            className="mt-2 flex items-center border-0  text-blue-500 font-semibold"
                            icon={<PlusOutlined />}
                            shape="round"
                            onClick={() => add({ isNew: true })}
                          >
                            Add Connector
                          </Button>
                        </div>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Col>
            </Row>

            <div className="m-auto pt-6 flex justify-center space-x-4">
              <Form.Item colon={false}>
                <Button
                  className="w-36"
                  type="primary"
                  ghost
                  shape="round"
                  htmlType="button"
                  onClick={() => {
                    history.push({
                      pathname: "/charger",
                      searchValue: history.location.searchValue,
                      pageValue: history.location.pageValue,
                    });
                  }}
                >
                  Cancel
                </Button>
              </Form.Item>
              <Form.Item colon={false}>
                <Button
                  className="w-36"
                  key="save"
                  type="primary"
                  shape="round"
                  htmlType="submit"
                  disabled={disabled}
                >
                  Save
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
      <ModalQR
        openModal={!!qrCode}
        qrValue={qrCode}
        onCancel={() => setQrCode(null)}
      />
      <Prompt when={change} message="Changes will not be saved. Do you want to proceed ?" />
    </>
  );
};
export default ChargerSetting;
